export default __webpack_public_path__ + "static/media/silhouette-girl5.da33c7dc.svg";